import React, { useState, useEffect } from 'react';
import "./home.css";
import wood1 from "./img/wood1.jpg"
import ContactSection from './Contacto';
import MediaGallery from './componentes/Cimage';
import { imagenesPreview } from './img-previews';
import PreFooter from './componentes/Pre-footer';
import Servicios from './componentes/Servicios';


const Home = () => {


  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);

  // Productos preview
  const products = [
    { id: 1, name: 'Bancas', image: imagenesPreview.BANCAS },
    { id: 2, name: 'Esquineros', image: imagenesPreview.ESQUINEROS },
    { id: 3, name: 'Fruteros', image: imagenesPreview.FRUTEROS },
    { id: 4, name: 'Mesas', image: imagenesPreview.MESAS }
  ];



  return (
    <div className="home-container">
  
<MediaGallery/>
      {/* Sección de productos preview */}
    <section className="products-preview-section">
      <h2 className="section-title">Nuestra Colección</h2>
      <div className="products-grid">
        {products.map((product) => (
          <div key={product.id} className="product-card">
            <img 
              src={product.image} 
              alt={product.name} 
              className="product-image" 
              onError={(e) => {
                // Fallback si la imagen no carga
                e.target.src = '/images/placeholder.jpg';
              }}
            />
            <h3>{product.name}</h3>
            <button 
              className="product-button"
              onClick={() => window.location.href = '/Productos'}
            >
              Ver más
            </button>
          </div>
        ))}
      </div>
    </section>


       <Servicios/>   
      <ContactSection />
      <PreFooter/>
    </div>
  );
};

export default Home;